import React, { useState, useEffect } from "react";
import { Row, Col, Modal, Form, Badge, Button, Table, Spinner } from "react-bootstrap";
import { FaLock, FaCheck, FaTimes, FaExclamationTriangle, FaPlus, FaShieldAlt, FaSearch, FaBrain, FaBug } from "react-icons/fa";
import axios from "axios";
import { useAuth } from "../../contexts/AuthContext";
import "../../ComponentsCss/professional-privacy-forms.css";


/* â”€â”€ SUSAN brand tokens (matches UnifiedPrivacyModule) â”€â”€ */
const T = {
  brand:        '#0095C4',
  brandLight:   'rgba(0, 149, 196, 0.10)',
  cyan:         '#6BCEEF',
  success:      '#33A148',
  warning:      '#FFF000',
  error:        '#DC3545',
  white:        '#FFFFFF',
  bodyBg:       '#F3F5F8',
  cardBg:       '#FFFFFF',
  cardShadow:   '0 2px 12px rgba(0,0,0,0.08)',
  textPrimary:  '#1A2332',
  textSecondary:'#5A6577',
  textMuted:    '#8E99A8',
  border:       '#E2E6EC',
  borderLight:  '#F0F2F5',
  radiusSm:     '6px',
  radiusMd:     '10px',
  radiusLg:     '14px',
  font:         "'Inter', -apple-system, BlinkMacSystemFont, sans-serif",
};

const scoreColor = v => v > 70 ? '#198754' : v > 40 ? '#fd7e14' : '#dc3545';


const SecurityEncryptionTab = ({ userData, onScoreUpdate,logToAccessLogs }) => {
  /* â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•
   * ALL ORIGINAL STATE â€” 100% PRESERVED
   * â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â• */
  const [encryptionData, setEncryptionData] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [newEntry, setNewEntry] = useState({
    dataType: "",
    dataLocation: "",
    dataSource: "",
    dataDestination: "",
    dataState: "At Rest",
    encryption: "AES-256",
    access: "RBAC",
    backupEncrypted: false
  });
  const [scanResult, setScanResult] = useState(null);
  const [scanModal, setScanModal] = useState(false);
  const [scanLoading, setScanLoading] = useState(false);
  const [aiReport, setAiReport] = useState('');
  const [showReportModal, setShowReportModal] = useState(false);
  const [aiVulns, setAiVulns] = useState(null);
  const [showVulnModal, setShowVulnModal] = useState(false);
  const [toast, setToast] = useState({ show: false, message: '', variant: 'success' });
  const { profile } = useAuth();
  const organizationId = profile?.orgId;


  /* â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•
   * ALL ORIGINAL LOGIC â€” 100% PRESERVED
   * â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â• */
  const showToast = (msg, variant = 'success') => {
    setToast({ show: true, message: msg, variant });
    setTimeout(() => {
      setToast({ show: false, message: '', variant: 'success' });
    }, 3000);
  };
  const btnPrimary = {
  padding: "12px 16px", borderRadius: "8px", fontSize: "14px", fontWeight: 600,
   cursor: "pointer", border: "none",backgroundColor:"#024A82",color:"#FFFFF",
   fontFamily:"'Inter', sans-serif",
   display: "inline-flex",
  alignItems: "center", gap: "5px",
};

  const getUserRegion = () => sessionStorage.getItem('userRegion') || 'GB';
  const headers = {
    Region: getUserRegion() || "GB",
    organizationId: organizationId
  };

  const logActivity = async (message, badge = "info") => {
    try {
      await axios.post(
        "https://ugat9qq1mj.execute-api.ap-southeast-2.amazonaws.com/prod/api/dpdp/activities/create",
        { message, badge, timestamp: new Date().toISOString() },
        { headers: { Region: getUserRegion(), organizationId: organizationId } }
      );
    } catch (err) {
      console.warn("Failed to log activity:", err.message);
    }
  };

  const generateAIReport = async () => {
    try {
      const res = await axios.get("https://m08aeftv3m.execute-api.ap-southeast-2.amazonaws.com/prod/api/encryption-items/scan/ai-report", { headers });
      await logActivity("AI security report generated", "info");
      logToAccessLogs?.({
  action:   'AI Report Generated',
  severity: 'info',
  description: 'AI security report generated for the organization',});
      setAiReport(res.data);
      setShowReportModal(true);
    } catch (e) { console.error(e); }
  };

  const viewAIVulnerabilities = async () => {
    try {
      const res = await axios.get("https://uo437sy16a.execute-api.ap-southeast-2.amazonaws.com/prod/api/encryption-items/scan/ai-vulnerabilities", { headers });
      await logActivity("Viewed AI-predicted vulnerabilities", "danger");
      logToAccessLogs?.({
  action:   'Vulnerabilities Viewed',
  severity: 'warning',
  description: 'AI-predicted vulnerability report accessed',});
      setAiVulns(res.data);
      setShowVulnModal(true);
    } catch (e) {
      console.error("Error loading AI vulnerabilities:", e);
    }
  };

  const runScan = async () => {
    setScanLoading(true);
    try {
      const res = await axios.get("https://8t28l0uq12.execute-api.ap-southeast-2.amazonaws.com/prod/api/encryption-items/scan", { headers });
      await logActivity("Security scan completed", "warning");
      logToAccessLogs?.({
  action:      'Security Scan Run',
  severity:    'warning',
  description: `Security scan completed â€” Score: ${scanResult?.summary?.score ?? '?'}%, Issues: ${scanResult?.summary?.totalIssues ?? '?'}`,});
      setScanResult(res.data);
      setScanModal(true);
    } catch (e) {
      console.error("Scan failed", e);
    } finally {
      setScanLoading(false);
    }
  };

  const getBadge = (type, value) => {
    const variantMap = {
      encryption: { "AES-256": "success", "Partial": "warning", "None": "danger" },
      access: {
        "RBAC": "success", "Auth + MFA": "success", "PKI (Certificate-based)": "success",
        "Biometrics": "success", "Username/Password": "warning", "Basic Auth": "warning",
        "No Access Control": "danger",
      },
      risk: { "Low": "success", "Medium": "warning", "High": "danger" },
      dataState: { "At Rest": "primary", "In Transit": "info" }
    };
    return (
      <Badge bg={variantMap[type]?.[value] || "secondary"}>
        {type === "encryption" && value === "AES-256" && <FaLock className="me-1" />}
        {type === "encryption" && value === "Partial" && <FaExclamationTriangle className="me-1" />}
        {value}
      </Badge>
    );
  };

  const calculateRisk = (entry) => {
    let riskScore = 0;
    if (entry.encryption === "None") riskScore += 3;
    else if (entry.encryption === "Partial") riskScore += 1;
    if (entry.access === "No Access Control") riskScore += 3;
    else if (entry.access === "Username/Password" || entry.access === "Basic Auth") riskScore += 1;
    if (!entry.backupEncrypted) riskScore += 2;
    if (entry.dataState === "In Transit" && entry.encryption !== "AES-256") riskScore += 2;
    if (riskScore >= 5) return "High";
    if (riskScore >= 2) return "Medium";
    return "Low";
  };

  const fetchData = async () => {
    try {
      const res = await axios.get("https://osuykh2mcb.execute-api.ap-southeast-2.amazonaws.com/prod/api/encryption-items/list", { headers });
      setEncryptionData(res.data);
    } catch (err) {
      console.error("Error fetching encryption items", err);
    }
  };

  const handleCreate = async () => {
    if (!newEntry.dataType || !newEntry.dataLocation) {
      showToast("Please fill all required fields", "danger");
      return;
    }
    try {
      const payload = { ...newEntry, riskLevel: calculateRisk(newEntry) };
      await axios.post("https://0axnkyma6a.execute-api.ap-southeast-2.amazonaws.com/prod/api/encryption-items/create", payload, { headers });
      await logActivity(`Added encryption item for ${newEntry.dataType}`, "success");
      logToAccessLogs?.({
  action:      'Security Entry Created',
  severity:    'success',
  description: `Added security entry for ${newEntry.dataType} â€” Risk: ${calculateRisk(newEntry)}`,});

      showToast("Security item created successfully", "success");
      fetchData();
      setShowModal(false);
      setNewEntry({
        dataType: "", dataLocation: "", dataSource: "", dataDestination: "",
        dataState: "At Rest", encryption: "AES-256", access: "RBAC", backupEncrypted: false
      });
    } catch (err) {
      console.error("Failed to save encryption item", err);
      showToast("Failed to create security item", "danger");
    }
  };

  useEffect(() => { fetchData(); }, []);

  const issues = encryptionData.length === 0 ? 0 : encryptionData.filter((item) => item.riskLevel !== "Low").length;
  const score = encryptionData.length === 0 ? 0 : Math.max(0, 100 - issues * 10);

  useEffect(() => {
    if (onScoreUpdate) onScoreUpdate(score);
  }, [score, encryptionData]);


  /* â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•
   * SCORE RING SVG (matches dashboard ring style)
   * â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â• */
  const ringRadius = 34;
  const ringCircumference = 2 * Math.PI * ringRadius;
  const ringOffset = ringCircumference - (ringCircumference * score / 100);
  const ringColor = score > 70 ? T.success : score > 40 ? '#fd7e14' : T.error;


  /* â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•
   * INLINE STYLES â€” matches unified dashboard design language
   * â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â• */
  const S = {
    page: {
      fontFamily: T.font, padding: '0', background: 'transparent',
    },
    sectionCard: {
      background: T.cardBg, borderRadius: T.radiusLg, padding: '24px',
      boxShadow: T.cardShadow, border: `1px solid ${T.borderLight}`, marginBottom: '20px',
    },
    sectionTitle: {
      fontSize: '15px', fontWeight: 600, color: T.textPrimary, marginBottom: '20px',
      display: 'flex', alignItems: 'center', justifyContent: 'space-between',
    },
    addBtn: {
      padding: '7px 16px', borderRadius: '8px', fontSize: '12.5px', fontWeight: 600,
      background: T.brand, color: T.white, border: 'none', cursor: 'pointer',
      display: 'flex', alignItems: 'center', gap: '6px', fontFamily: T.font,
      transition: 'background 0.2s',
    },
    table: {
      width: '100%', borderCollapse: 'separate', borderSpacing: 0,
      fontSize: '13px', fontFamily: T.font,
    },
    th: {
      padding: '10px 14px', fontSize: '11px', fontWeight: 600, color: T.textMuted,
      textTransform: 'uppercase', letterSpacing: '0.5px', borderBottom: `2px solid ${T.border}`,
      background: T.borderLight, whiteSpace: 'nowrap',
    },
    td: {
      padding: '12px 14px', borderBottom: `1px solid ${T.borderLight}`,
      color: T.textSecondary, fontSize: '13px', verticalAlign: 'middle',
    },
    actionBtn: (variant) => ({
      width: '100%', padding: '10px 14px', borderRadius: T.radiusMd,
      fontSize: '13px', fontWeight: 500, cursor: 'pointer', fontFamily: T.font,
      display: 'flex', alignItems: 'center', gap: '10px', transition: 'all 0.2s',
      textAlign: 'left',
      ...(variant === 'primary'
        ? { background: T.brand, color: T.white, border: `1px solid ${T.brand}` }
        : variant === 'outline'
          ? { background: T.cardBg, color: T.brand, border: `1px solid ${T.border}` }
          : { background: T.cardBg, color: T.error, border: `1px solid ${T.border}` }
      ),
    }),
    kpiMini: {
      background: T.borderLight, borderRadius: T.radiusMd, padding: '14px 16px',
      textAlign: 'center', flex: 1,
    },
    kpiMiniValue: (color) => ({
      fontSize: '20px', fontWeight: 700, color: color, fontVariantNumeric: 'tabular-nums',
    }),
    kpiMiniLabel: {
      fontSize: '11px', color: T.textMuted, marginTop: '2px',
    },
    toast: (variant) => ({
      position: 'fixed', top: '16px', right: '16px', zIndex: 9999,
      padding: '12px 20px', borderRadius: T.radiusMd,
      fontSize: '13px', fontWeight: 500, fontFamily: T.font,
      maxWidth: '360px', minWidth: '250px',
      display: 'flex', alignItems: 'center', gap: '10px',
      boxShadow: '0 4px 20px rgba(0,0,0,0.15)',
      background: variant === 'success' ? '#d4edda' : variant === 'danger' ? '#f8d7da' : '#fff3cd',
      color: variant === 'success' ? '#155724' : variant === 'danger' ? '#721c24' : '#856404',
      border: `1px solid ${variant === 'success' ? '#c3e6cb' : variant === 'danger' ? '#f5c6cb' : '#ffc107'}`,
    }),
  };


  /* â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•
   * RENDER â€” Redesigned layout matching unified dashboard
   * All logic, APIs, data flow 100% original
   * â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â• */
  return (
    <div style={S.page}>

      {/* Toast Notification */}
      {toast.show && (
        <div style={S.toast(toast.variant)}>
          <span style={{ flex: 1 }}>{toast.message}</span>
          <span style={{ cursor: 'pointer', fontSize: '16px', lineHeight: 1 }}
            onClick={() => setToast({ show: false, message: '', variant: 'success' })}>Ã—</span>
        </div>
      )}


      {/* TOP ROW â€” Score Ring + KPI Summary + Quick Actions */}
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 2fr 1fr', gap: '20px', marginBottom: '20px' }}>

        {/* Security Score Ring */}
        <div style={{ ...S.sectionCard, marginBottom: 0, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', padding: '28px 20px' }}>
          <svg width="90" height="90" viewBox="0 0 80 80" style={{ marginBottom: '12px' }}>
            <circle cx="40" cy="40" r={ringRadius} fill="none" stroke={T.border} strokeWidth="8" />
            <circle cx="40" cy="40" r={ringRadius} fill="none" stroke={ringColor} strokeWidth="8"
              strokeDasharray={ringCircumference} strokeDashoffset={ringOffset}
              strokeLinecap="round" transform="rotate(-90 40 40)"
              style={{ transition: 'stroke-dashoffset 1.5s cubic-bezier(0.22,1,0.36,1)' }} />
            <text x="40" y="44" textAnchor="middle" fontFamily="Inter,sans-serif" fontSize="16" fontWeight="700" fill={T.textPrimary}>
              {score}%
            </text>
          </svg>
          <div style={{ fontSize: '13px', fontWeight: 600, color: T.textPrimary }}>Security Score</div>
          <div style={{ fontSize: '11px', color: T.textMuted, marginTop: '2px' }}>
            {issues === 0 ? 'All items healthy' : `${issues} item${issues > 1 ? 's' : ''} need attention`}
          </div>
        </div>

        {/* KPI Summary Cards */}
        <div style={{ ...S.sectionCard, marginBottom: 0, display: 'flex', gap: '14px', alignItems: 'stretch', padding: '20px 24px' }}>
          {[
            { label: 'Total Entries', value: encryptionData.length, color: T.brand },
            { label: 'Low Risk', value: encryptionData.filter(i => i.riskLevel === 'Low').length, color: T.success },
            { label: 'Medium Risk', value: encryptionData.filter(i => i.riskLevel === 'Medium').length, color: '#fd7e14' },
            { label: 'High Risk', value: encryptionData.filter(i => i.riskLevel === 'High').length, color: T.error },
            { label: 'Encrypted Backups', value: encryptionData.filter(i => i.backupEncrypted).length, color: '#7c3aed' },
          ].map((kpi, i) => (
            <div key={i} style={S.kpiMini}>
              <div style={S.kpiMiniValue(kpi.color)}>{kpi.value}</div>
              <div style={S.kpiMiniLabel}>{kpi.label}</div>
            </div>
          ))}
        </div>

        {/* Quick Actions */}
        <div style={{ ...S.sectionCard, marginBottom: 0, display: 'flex', flexDirection: 'column', gap: '8px', padding: '20px' }}>
          <div style={{ fontSize: '13px', fontWeight: 600, color: T.textPrimary, marginBottom: '4px' }}>Quick Actions</div>
          <button style={S.actionBtn('primary')} onClick={runScan} disabled={scanLoading}
            onMouseEnter={e => { e.currentTarget.style.background = '#007DAA'; }}
            onMouseLeave={e => { e.currentTarget.style.background = T.brand; }}>
            {scanLoading ? <Spinner animation="border" size="sm" /> : <FaSearch style={{ fontSize: '0.8rem' }} />}
            {scanLoading ? 'Scanning...' : 'Run Security Scan'}
          </button>
          <button style={S.actionBtn('outline')} onClick={generateAIReport}
            onMouseEnter={e => { e.currentTarget.style.background = T.brandLight; e.currentTarget.style.borderColor = T.brand; }}
            onMouseLeave={e => { e.currentTarget.style.background = T.cardBg; e.currentTarget.style.borderColor = T.border; }}>
            <FaBrain style={{ fontSize: '0.8rem' }} /> Generate AI Report
          </button>
          <button style={S.actionBtn('danger')} onClick={viewAIVulnerabilities}
            onMouseEnter={e => { e.currentTarget.style.background = 'rgba(220,53,69,0.06)'; e.currentTarget.style.borderColor = T.error; }}
            onMouseLeave={e => { e.currentTarget.style.background = T.cardBg; e.currentTarget.style.borderColor = T.border; }}>
            <FaBug style={{ fontSize: '0.8rem' }} /> View Vulnerabilities
          </button>
        </div>
      </div>


      {/* MAIN TABLE â€” Data Security Assessment */}
      <div style={S.sectionCard}>
        <div style={S.sectionTitle}>
          <span>Data Security Assessment</span>
          <button style={S.addBtn} onClick={() => setShowModal(true)}
            onMouseEnter={e => { e.currentTarget.style.background = '#007DAA'; }}
            onMouseLeave={e => { e.currentTarget.style.background = T.brand; }}>
            <FaPlus style={{ fontSize: '10px' }} /> Add Security Entry
          </button>
        </div>

        <div style={{ overflowX: 'auto', borderRadius: T.radiusMd, border: `1px solid ${T.borderLight}` }}>
          <table style={S.table}>
            <thead>
              <tr>
                {['Data Type', 'Location', 'Source', 'Destination', 'State', 'Encryption', 'Access Control', 'Backup', 'Risk'].map(h => (
                  <th key={h} style={S.th}>{h}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {encryptionData.map((item, index) => (
                <tr key={index} style={{ transition: 'background 0.15s' }}
                  onMouseEnter={e => { e.currentTarget.style.background = T.borderLight; }}
                  onMouseLeave={e => { e.currentTarget.style.background = 'transparent'; }}>
                  <td style={{ ...S.td, fontWeight: 500, color: T.textPrimary }}>{item.dataType}</td>
                  <td style={S.td}>{item.dataLocation || item.location}</td>
                  <td style={{ ...S.td, color: T.textMuted }}>{item.dataSource || "â€”"}</td>
                  <td style={{ ...S.td, color: T.textMuted }}>{item.dataDestination || "â€”"}</td>
                  <td style={S.td}>{getBadge("dataState", item.dataState || "At Rest")}</td>
                  <td style={S.td}>{getBadge("encryption", item.encryption)}</td>
                  <td style={S.td}>{getBadge("access", item.access)}</td>
                  <td style={{ ...S.td, textAlign: 'center' }}>
                    {item.backupEncrypted
                      ? <FaCheck style={{ color: T.success }} />
                      : <FaTimes style={{ color: T.error }} />
                    }
                  </td>
                  <td style={S.td}>{getBadge("risk", item.riskLevel)}</td>
                </tr>
              ))}
              {encryptionData.length === 0 && (
                <tr>
                  <td colSpan="9" style={{ ...S.td, textAlign: 'center', padding: '40px 14px', color: T.textMuted }}>
                    <div style={{ fontSize: '1.5rem', marginBottom: '8px' }}>ðŸ”’</div>
                    No security entries found. Add your first entry to begin assessment.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>


      {/* â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•
       * ALL ORIGINAL MODALS â€” 100% PRESERVED (logic + structure)
       * â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â• */}

      {/* AI Report Modal */}
      <Modal show={showReportModal} onHide={() => setShowReportModal(false)} size="lg">
        <Modal.Header closeButton><Modal.Title>AI Security Report</Modal.Title></Modal.Header>
        <Modal.Body>
          <pre style={{ whiteSpace: 'pre-wrap' }}>{aiReport}</pre>
        </Modal.Body>
      </Modal>

      {/* AI Vulnerabilities Modal */}
      <Modal show={showVulnModal} onHide={() => setShowVulnModal(false)} size="lg">
        <Modal.Header closeButton><Modal.Title>AI Vulnerabilities</Modal.Title></Modal.Header>
        <Modal.Body>
          {!aiVulns ? 'Loading...' : (
            <Table striped bordered hover responsive>
              <thead>
                <tr>
                  <th>ID</th><th>Severity</th><th>Issue</th><th>Impact</th>
                  <th>Recommendation</th><th>Owner</th><th>ETA</th>
                </tr>
              </thead>
              <tbody>
                {aiVulns.vulnerabilities.map(v => (
                  <tr key={v.id}>
                    <td>{v.id}</td>
                    <td>{v.severity}</td>
                    <td>{v.issue}</td>
                    <td>{v.impact}</td>
                    <td>{v.recommendation}</td>
                    <td>{v.owner}</td>
                    <td>{v.eta}</td>
                  </tr>
                ))}
              </tbody>
            </Table>
          )}
        </Modal.Body>
      </Modal>

      {/* Scan Results Modal */}
      <Modal show={scanModal} onHide={() => setScanModal(false)} size="lg">
        <Modal.Header closeButton>
          <Modal.Title>Security Scan Results</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {!scanResult ? (
            <p>No results.</p>
          ) : (
            <>
              <h6 className="mb-3">
                Score: {scanResult.summary.score}% | Issues: {scanResult.summary.totalIssues} |
                High: {scanResult.summary.high}, Medium: {scanResult.summary.medium}
              </h6>
              <Table striped bordered hover responsive>
                <thead>
                  <tr>
                    <th>Data Type</th>
                    <th>Computed Risk</th>
                    <th>Issues</th>
                    <th>Recommendation</th>
                  </tr>
                </thead>
                <tbody>
                  {scanResult.results.map((r) => (
                    <tr key={r.itemId}>
                      <td>{r.dataType}</td>
                      <td>{r.computedRiskLevel}</td>
                      <td>
                        <ul className="mb-0">
                          {r.issues.map((i, idx) => (
                            <li key={idx}>
                              <Badge bg={i.severity === 'HIGH' ? 'danger' : i.severity === 'MEDIUM' ? 'warning' : 'secondary'} className="me-1">
                                {i.severity}
                              </Badge>
                              {i.field}: {i.message}
                            </li>
                          ))}
                        </ul>
                      </td>
                      <td>{r.recommendation}</td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setScanModal(false)}>Close</Button>
        </Modal.Footer>
      </Modal>

      {/* Add/Edit Entry Modal */}
      <Modal
        show={showModal}
        onHide={() => setShowModal(false)}
        size="lg"
        centered
        backdrop="static"
        keyboard={true}
        dialogClassName="privacy-pro-modal"
      >
        <Modal.Header closeButton>
           <div>
          <Modal.Title>Add Security Entry</Modal.Title>
           <div className="modal-subtitle">
        Define encryption, access control and data protection posture
      </div>
    </div>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <div className="privacy-form-section">
        <div className="privacy-form-section-title">
          1. Data Flow Information
        </div>
            <Row>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>Data Type <span className="text-danger">*</span></Form.Label>
                  <Form.Control
                    type="text"
                    value={newEntry.dataType}
                    onChange={(e) => setNewEntry({ ...newEntry, dataType: e.target.value })}
                    placeholder="e.g., Customer PII, Financial Records"
                  />
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>Data Location <span className="text-danger">*</span></Form.Label>
                  <Form.Control
                    type="text"
                    value={newEntry.dataLocation}
                    onChange={(e) => setNewEntry({ ...newEntry, dataLocation: e.target.value })}
                    placeholder="e.g., AWS S3, On-Premises Server"
                  />
                </Form.Group>
              </Col>
            </Row>

            <Row>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>Data Source</Form.Label>
                  <Form.Control
                    type="text"
                    value={newEntry.dataSource}
                    onChange={(e) => setNewEntry({ ...newEntry, dataSource: e.target.value })}
                    placeholder="e.g., Web Application, Mobile App"
                  />
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>Data Destination</Form.Label>
                  <Form.Control
                    type="text"
                    value={newEntry.dataDestination}
                    onChange={(e) => setNewEntry({ ...newEntry, dataDestination: e.target.value })}
                    placeholder="e.g., Database, Data Warehouse"
                  />
                </Form.Group>
              </Col>
            </Row>
            </div>

<div className="privacy-form-section">
        <div className="privacy-form-section-title">
          2. Encryption & Access Controls
        </div>
            <Row>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>Data State <span className="text-danger">*</span></Form.Label>
                  <Form.Select
                    value={newEntry.dataState}
                    onChange={(e) => setNewEntry({ ...newEntry, dataState: e.target.value })}
                  >
                    <option value="At Rest">At Rest</option>
                    <option value="In Transit">In Transit</option>
                  </Form.Select>
                  <Form.Text className="text-muted">
                    {newEntry.dataState === "In Transit" ?
                      "Data moving between systems" :
                      "Data stored in databases/files"}
                  </Form.Text>
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>Encryption Standard</Form.Label>
                  <Form.Select
                    value={newEntry.encryption}
                    onChange={(e) => setNewEntry({ ...newEntry, encryption: e.target.value })}
                  >
                    <option value="AES-256">AES-256 (Recommended)</option>
                    <option value="Partial">Partial Encryption</option>
                    <option value="None">No Encryption</option>
                  </Form.Select>
                </Form.Group>
              </Col>
            </Row>

            <Form.Group className="mb-3">
              <Form.Label>Access Control Method</Form.Label>
              <Form.Select
                value={newEntry.access}
                onChange={(e) => setNewEntry({ ...newEntry, access: e.target.value })}
              >
                <optgroup label="Strong Authentication">
                  <option value="Auth + MFA">Authentication + MFA (Multi-Factor)</option>
                  <option value="PKI (Certificate-based)">PKI (Certificate-based Authentication)</option>
                  <option value="Biometrics">Biometrics (Fingerprint/Face/Retina/Voice)</option>
                  <option value="RBAC">RBAC (Role-Based Access Control)</option>
                </optgroup>
                <optgroup label="Basic Authentication">
                  <option value="Username/Password">Username/Password</option>
                  <option value="Basic Auth">Basic Auth</option>
                </optgroup>
                <optgroup label="No Security">
                  <option value="No Access Control">No Access Control</option>
                </optgroup>
              </Form.Select>
            </Form.Group>
            <Form.Check
              type="checkbox"
              label="Backup data is encrypted"
              checked={newEntry.backupEncrypted}
              onChange={(e) => setNewEntry({ ...newEntry, backupEncrypted: e.target.checked })}
              className="mb-3"
            />
             </div>

 <div className="privacy-risk-card">
        <div className="risk-card-left">
          <strong>Calculated Risk Level</strong>
          <span>Based on encryption, access control, backup encryption and data state</span>
        </div>

        <div className="risk-card-badge">
          {getBadge("risk", calculateRisk(newEntry))}
        </div>
      </div>
    </Form>
  </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowModal(false)}>Cancel</Button>
          <Button variant="" style={btnPrimary} className="text-white" onClick={handleCreate}>Save Security Entry</Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};


export default SecurityEncryptionTab;